//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      locals: {
        AtmId: null,
        RenterFrontId: null,
      },
      filters: {
        OrderId: null,
        RenterFrontId: null,
        OrderTypeName: null,
        OrderStatusName: null,
        TransferId: null,
        OrgName: null,
        BaseCurrencyName: null,
        QuoteCurrencyName: null,
        CurrencyRateFrom: null,
        CurrencyRateTo: null,
        AtmId: null,
        DateCreatedFrom: null,
        DateCreatedTo: null,
      },
      constant,
    };
  },

  computed: {
    ...mapState('cryptomatsAtms', {
      filterLists: 'filters',
    }),
    ...mapState('cryptomatsRenters', ['rentersList', 'rentersNames']),
    ...mapState('currencies', ['currencies']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('cryptomatsAtms', [
      'setFilters',
    ]),

    handleLocalValue(key, value) {
      this.filters[key] = value;
    },
  },
};
